var map = {
	"./10_club.jpg": 5480,
	"./10_diamond.jpg": 9530,
	"./10_heart.jpg": 5254,
	"./10_spade.jpg": 9285,
	"./2_club.jpg": 8145,
	"./2_diamond.jpg": 9149,
	"./2_heart.jpg": 3393,
	"./2_spade.jpg": 8646,
	"./3_club.jpg": 9558,
	"./3_diamond.jpg": 1980,
	"./3_heart.jpg": 8948,
	"./3_spade.jpg": 9355,
	"./4_club.jpg": 399,
	"./4_diamond.jpg": 183,
	"./4_heart.jpg": 3631,
	"./4_spade.jpg": 1892,
	"./5_club.jpg": 3068,
	"./5_diamond.jpg": 5582,
	"./5_heart.jpg": 4866,
	"./5_spade.jpg": 5905,
	"./6_club.jpg": 4013,
	"./6_diamond.jpg": 6601,
	"./6_heart.jpg": 9941,
	"./6_spade.jpg": 2314,
	"./7_club.jpg": 6274,
	"./7_diamond.jpg": 1768,
	"./7_heart.jpg": 3176,
	"./7_spade.jpg": 4687,
	"./8_club.jpg": 8891,
	"./8_diamond.jpg": 5923,
	"./8_heart.jpg": 4675,
	"./8_spade.jpg": 8648,
	"./9_club.jpg": 2776,
	"./9_diamond.jpg": 2890,
	"./9_heart.jpg": 3510,
	"./9_spade.jpg": 4821,
	"./a_club.jpg": 8544,
	"./a_diamond.jpg": 2226,
	"./a_heart.jpg": 6270,
	"./a_spade.jpg": 3869,
	"./j_club.jpg": 7433,
	"./j_diamond.jpg": 7093,
	"./j_heart.jpg": 6857,
	"./j_spade.jpg": 2222,
	"./k_club.jpg": 894,
	"./k_diamond.jpg": 2228,
	"./k_heart.jpg": 6748,
	"./k_spade.jpg": 9955,
	"./q_club.jpg": 8752,
	"./q_diamond.jpg": 3778,
	"./q_heart.jpg": 3822,
	"./q_spade.jpg": 8381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;